// AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { firebase } from "../../../firebase/config";
import mixpanel from "mixpanel-browser";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(null);
  const [loading, setLoading] = useState(true);
  const [credits, setCredits] = useState(null);
  const [paid, setPaid] = useState(null);

  useEffect(() => {
    if (firebase.auth().currentUser) {
      const uid = firebase.auth().currentUser.uid;
      mixpanel.identify(uid);
      firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .onSnapshot((doc) => {
          if (doc.data()) {
            setCredits(doc.data().credits);
            setPaid(doc.data().paid);
          }
        });
    }
  }, [firebase.auth().currentUser]);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      setLoggedIn(!!user);
      setLoading(false);
    });

    return unsubscribe; // Unsubscribe on unmount
  }, []);

  return (
    <AuthContext.Provider value={{ loggedIn, loading, credits, paid }}>
      {children}
    </AuthContext.Provider>
  );
};
